/**
 * Safely get the return value of a function accessing nested object properties.
 *
 * @param fn
 * @param defaultValue
 * @returns {*}
 */
export default function getSafe(fn, defaultValue = null) {
  try {
    return fn();
  } catch (e) {
    return defaultValue;
  }
}
